import { TemplateRef } from '@angular/core';
import { AccountService } from '../../core/auth/account.service';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Feedback } from '../model/feedback.model';
import { UserService } from '../../core/user/user.service';
import moment from "moment";
import { TrackerActivityFactoryService } from '../../core/tracker/tracker-activity-factory.service';
import { Router } from "@angular/router";
import { FeedbackService } from '../../entities/feedback/feedback.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import { CustomerCareModalComponent } from '../support/customer-care-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "../../core/auth/account.service";
import * as i2 from "../../core/user/user.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "../../entities/feedback/feedback.service";
import * as i5 from "@angular/router";
import * as i6 from "../../core/tracker/tracker-activity-factory.service";
import * as i7 from "../../ng-jhipster/language";
import * as i8 from "../../ng-jhipster/service";
import * as i9 from "@fortawesome/angular-fontawesome";
import * as i10 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i11 from "@angular/common";
import * as i12 from "@angular/forms";
import * as i13 from "@ngx-translate/core";
const _c0 = ["supportDropdown"];
const _c1 = ["feedbackModal"];
const _c2 = function (a0) { return { "feedback-star-hover": a0 }; };
function SupportDropdownComponent_ng_template_22_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "fa-icon", 30);
    i0.ɵɵlistener("mouseenter", function SupportDropdownComponent_ng_template_22_div_7_Template_fa_icon_mouseenter_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r8); const i_r6 = restoredCtx.index; const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.highlightStar($event, i_r6 + 1); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r6 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2, i_r6 < ctx_r3.highLightIndex));
} }
function SupportDropdownComponent_ng_template_22_p_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 31);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("jhiTranslate", ctx_r4.starText);
} }
function SupportDropdownComponent_ng_template_22_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "img", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 19);
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵelement(5, "input", 21);
    i0.ɵɵelementStart(6, "div", 22);
    i0.ɵɵtemplate(7, SupportDropdownComponent_ng_template_22_div_7_Template, 2, 3, "div", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 24);
    i0.ɵɵtemplate(9, SupportDropdownComponent_ng_template_22_p_9_Template, 1, 1, "p", 25);
    i0.ɵɵelementStart(10, "textarea", 26);
    i0.ɵɵlistener("ngModelChange", function SupportDropdownComponent_ng_template_22_Template_textarea_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.comment = $event; });
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 27);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 24);
    i0.ɵɵelementStart(15, "button", 28);
    i0.ɵɵlistener("click", function SupportDropdownComponent_ng_template_22_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.submitFeedback(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r1.stars);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.starText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(11, 5, "global.menu.support.tellUs"));
    i0.ɵɵproperty("ngModel", ctx_r1.comment);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.getCommentLength(), " / 250");
} }
export class SupportDropdownComponent {
    constructor(accountService, userService, modalService, feedbackService, router, trackerActivityFactoryService, languageService, eventManager) {
        this.accountService = accountService;
        this.userService = userService;
        this.modalService = modalService;
        this.feedbackService = feedbackService;
        this.router = router;
        this.trackerActivityFactoryService = trackerActivityFactoryService;
        this.languageService = languageService;
        this.eventManager = eventManager;
        this.isAuthenticated = this.accountService.isAuthenticated();
        this.stars = [1, 2, 3, 4, 5];
        this.highLightIndex = 3;
        this.starText = 'global.menu.support.stars.3';
        this.modalOptions = { windowClass: 'modal-window', size: 'sm' };
    }
    ngOnInit() {
        if (this.isAuthenticated) {
            this.userService.current().subscribe(u => {
                this.currentUser = u;
            });
        }
        this.eventManagerSubscription = this.eventManager.subscribe('openMessageUsPopup', () => this.openMessageModal());
    }
    openFaqPage() {
        const faqPageAddress = this.languageService.getCurrentLanguage() === 'nl' ? 'https://inukacoaching.com/nl/faq/' : 'https://inukacoaching.com/faq/';
        window.open(faqPageAddress, '_blank');
    }
    openFeedbackModal() {
        this.modalService.open(this.feedbackModal, { size: 'sm' }).result.then((result) => console.log(result));
    }
    openMessageModal() {
        this.modalService.open(CustomerCareModalComponent, this.modalOptions);
    }
    highlightStar($event, i) {
        this.highLightIndex = i;
        this.starText = 'global.menu.support.stars.' + this.highLightIndex;
    }
    getCommentLength() {
        return !this.comment ? 0 : this.comment.length;
    }
    submitFeedback() {
        let feedback = new Feedback();
        feedback.message = this.comment;
        feedback.rating = this.highLightIndex;
        feedback.creationDate = moment();
        feedback.userId = (this.isAuthenticated ? this.currentUser.id : this.trackerActivityFactoryService.getIdKey()).toString();
        feedback.location = this.router.url;
        this.feedbackService.createFeedback(feedback).subscribe(() => {
            console.log('Feedback saved successfully.');
            this.modalService.dismissAll();
        }, () => {
            console.log('Feedback cannot be saved.');
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this.eventManagerSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
}
SupportDropdownComponent.ɵfac = function SupportDropdownComponent_Factory(t) { return new (t || SupportDropdownComponent)(i0.ɵɵdirectiveInject(i1.AccountService), i0.ɵɵdirectiveInject(i2.UserService), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i4.FeedbackService), i0.ɵɵdirectiveInject(i5.Router), i0.ɵɵdirectiveInject(i6.TrackerActivityFactoryService), i0.ɵɵdirectiveInject(i7.JhiLanguageService), i0.ɵɵdirectiveInject(i8.JhiEventManager)); };
SupportDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SupportDropdownComponent, selectors: [["support-dropdown"]], viewQuery: function SupportDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.supportDropdown = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.feedbackModal = _t.first);
    } }, decls: 24, vars: 0, consts: [["ngbDropdown", "", 1, "olha-theme", "d-inline-block", "text-dark", "align-middle"], ["ngbDropdownToggle", "", "type", "button", 2, "-webkit-appearance", "none"], [1, "d-flex", "justify-content-center", "align-items-center", 2, "height", "27px", "width", "27px", "border", "1px solid #44a38d", "border-radius", "50%"], ["icon", "question", 1, "support-label"], ["ngbDropdownMenu", "", "aria-labelledby", "support-dropdown", 1, "dropdown-menu", "dropdown-menu-right", "dropdown-menu-location"], ["ngbDropdownItem", "", 1, "support-dropdown-item", 3, "click"], [2, "width", "1.4rem!important", "height", "1.4rem!important", "padding-right", "7px"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#message-dots"], ["jhiTranslate", "global.menu.support.sendMessage"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#message-question"], ["jhiTranslate", "global.menu.support.faq"], ["ngbDropdownItem", "", 1, "support-dropdown-item", 2, "padding-left", "14px!important", "padding-top", "0!important", 3, "click"], [2, "padding-right", "2px!important", "width", "1.5rem", "height", "1.5rem"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#heart-empty"], ["jhiTranslate", "global.menu.support.giveFeedback"], ["feedbackModal", ""], [1, "modal-body"], [2, "text-align", "center"], ["src", "../../../../content/images/inuka/logo-circle-black.png", "alt", "logo-circle-black", 2, "height", "30px", "width", "30px"], ["jhiTranslate", "global.menu.support.howSatisfied", 1, "block", "text-center", "font-weight-bold"], ["id", "app-rating", 1, "feedback-stars"], ["type", "hidden", "readonly", "readonly", "name", "feedback-stars-value", "id", "feedback-stars-value", "value", "5", 1, "feedback-value"], [1, "feedback-stars-container"], ["class", "feedback-star", 4, "ngFor", "ngForOf"], [1, "block", "text-center"], ["style", "color: darkgray", 3, "jhiTranslate", 4, "ngIf"], ["rows", "5", "maxlength", "250", 1, "form-control", 2, "height", "60px", 3, "ngModel", "placeholder", "ngModelChange"], [1, "text-right"], ["type", "button", "jhiTranslate", "global.menu.support.submit", 1, "btn-2", "btn-2-green", 2, "width", "120px", 3, "click"], [1, "feedback-star"], ["icon", "star", 3, "ngClass", "mouseenter"], [2, "color", "darkgray", 3, "jhiTranslate"]], template: function SupportDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵelementStart(2, "a", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div");
        i0.ɵɵelement(5, "fa-icon", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "ul", 4);
        i0.ɵɵelementStart(7, "li");
        i0.ɵɵelementStart(8, "a", 5);
        i0.ɵɵlistener("click", function SupportDropdownComponent_Template_a_click_8_listener() { return ctx.openMessageModal(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(9, "svg", 6);
        i0.ɵɵelement(10, "use", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(11, "span", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "li");
        i0.ɵɵelementStart(13, "a", 5);
        i0.ɵɵlistener("click", function SupportDropdownComponent_Template_a_click_13_listener() { return ctx.openFaqPage(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(14, "svg", 6);
        i0.ɵɵelement(15, "use", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(16, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "li");
        i0.ɵɵelementStart(18, "a", 11);
        i0.ɵɵlistener("click", function SupportDropdownComponent_Template_a_click_18_listener() { return ctx.openFeedbackModal(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(19, "svg", 12);
        i0.ɵɵelement(20, "use", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(21, "span", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, SupportDropdownComponent_ng_template_22_Template, 16, 7, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    } }, directives: [i3.NgbDropdown, i3.NgbDropdownToggle, i9.FaIconComponent, i3.NgbDropdownMenu, i3.NgbDropdownItem, i10.JhiTranslateDirective, i11.NgForOf, i11.NgIf, i12.DefaultValueAccessor, i12.MaxLengthValidator, i12.NgControlStatus, i12.NgModel, i11.NgClass], pipes: [i13.TranslatePipe], styles: ["a[_ngcontent-%COMP%]{padding-left:16px;text-decoration:none}a.dropdown-toggle[_ngcontent-%COMP%]{padding-left:0 !important}a.support-dropdown-item[_ngcontent-%COMP%]{margin-right:.5rem !important;background-color:#fff;color:#44a38d !important}a.support-dropdown-item[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{padding-right:.5rem;filter:invert(52%) sepia(63%) saturate(331%) hue-rotate(116deg) brightness(95%) contrast(91%)}a.support-dropdown-item[_ngcontent-%COMP%]:hover{margin-right:.5rem !important;background-color:#44a38d;color:#fff !important}a.support-dropdown-item[_ngcontent-%COMP%]:hover > img[_ngcontent-%COMP%]{padding-right:.5rem;filter:brightness(0) invert(1)}.dropdown-toggle[_ngcontent-%COMP%]::after{display:none}.feedback-star-hover[_ngcontent-%COMP%]{color:#44a38d}.feedback-stars[_ngcontent-%COMP%]   .feedback-stars-container[_ngcontent-%COMP%]   .feedback-star[_ngcontent-%COMP%]{display:inline-block;font-size:22px;cursor:pointer;padding:5px;color:#ebedf5}.feedback-stars-container[_ngcontent-%COMP%]{text-align:center}.support-label[_ngcontent-%COMP%]{font-size:16px;color:#44a38d}.dropdown-menu-location[_ngcontent-%COMP%]{top:30px !important;right:25px !important}"] });
